/** @file bookings/hold.js — on-hold workflow + booker-update requests. */
import { supabase } from "@/lib/supabaseClient";
import { BACKEND } from "../_shared";

export async function holdBooking(id, reason, user) {
  return supabase
    .from("lbs_bookings")
    .update({
      on_hold: true,
      hold_reason: reason || null,
      hold_set_by_user_id: user?.id || null,
      hold_set_at: new Date().toISOString(),
    })
    .eq("id", id)
    .select()
    .maybeSingle();
}

export async function unholdBooking(id) {
  return supabase
    .from("lbs_bookings")
    .update({
      on_hold: false,
      hold_reason: null,
      hold_set_by_user_id: null,
      hold_set_at: null,
    })
    .eq("id", id)
    .select()
    .maybeSingle();
}

export async function requestBookerUpdate(booking, missingFieldLabels, customNote) {
  let recipientEmail = null;
  let recipientName  = null;

  if (booking.approved_booker_id) {
    const { data } = await supabase
      .from("lbs_approved_bookers")
      .select("contact_email, name")
      .eq("id", booking.approved_booker_id)
      .maybeSingle();
    recipientEmail = data?.contact_email || null;
    recipientName  = data?.name || null;
  }
  if (!recipientEmail && booking.created_by_user_id) {
    const { data } = await supabase
      .from("lbs_user_profiles")
      .select("email, first_name, last_name")
      .eq("id", booking.created_by_user_id)
      .maybeSingle();
    recipientEmail = data?.email || null;
    recipientName  = data ? [data.first_name, data.last_name].filter(Boolean).join(" ") : null;
  }
  if (!recipientEmail) {
    return { error: { message: "No booker email on file for this booking." } };
  }

  const base = (typeof window !== "undefined" && window.location.origin) || "";
  const editUrl = `${base}/bookings?id=${booking.id}`;

  const context = {
    booking_id:       booking.id,
    reference_number: booking.reference_number || "",
    site_name:        booking.site?.name || "",
    scheduled_start:  booking.scheduled_start || "",
    missing_fields:   (missingFieldLabels || []).join(", "),
    custom_note:      customNote || "",
    booking_edit_url: editUrl,
    recipient_name:   recipientName || "",
  };

  const { error: mailErr } = await supabase
    .from("lbs_email_outbox")
    .insert({
      to_email:     recipientEmail,
      template_key: "booker_update_request",
      context,
      client_id:    booking.client_id || null,
      entity_type:  "booking",
      entity_id:    booking.id,
      status:       "pending",
    });
  if (mailErr) return { error: mailErr };

  await supabase
    .from("lbs_bookings")
    .update({ booker_update_requested_at: new Date().toISOString() })
    .eq("id", booking.id);

  return { data: { recipient: recipientEmail } };
}

/* =====================  BROKER / DRIVER VIEWS  ===================== */
